import React, { useEffect, useState, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import DataContext from "../Elements/eventContext";
import { ApiService } from "../Services/apiservices";
import "../Header/header.css";

function PagesHeader() {
  let apiServices = new ApiService();
  const location = useLocation();
  const contextValues = useContext(DataContext);
  const didMountRef = useRef(true);

  const [showStickyBtn, setShowStickyBtn] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  // Menu category popup states
  const [menuCategories, setMenuCategories] = useState([]);
  const [isMenuCategoriesOpen, setIsMenuCategoriesOpen] = useState(false);
  const [menuImageUrl, setMenuImageUrl] = useState("");

  useEffect(() => {
    if (didMountRef.current) {
      apiServices.settingsdataGetRequest().then((res) => {
        if (res.data && res.data.status == "success") {
          contextValues.setImageUrl(res.data.settings_url);
          contextValues.setSettingData(res.data.sitesettings);
        }
      });
      
      // Fetch menu categories
      apiServices.menucategoryGetRequest().then((res) => {
        if (res.data && res.data.status == "success") {
          setMenuCategories(res.data.category);
          setMenuImageUrl(res.data.menu_url);
        }
      });
    }
    didMountRef.current = false;
  }, []);

  useEffect(() => {
    const handleOpenMenu = () => setIsMenuCategoriesOpen(true);
    window.addEventListener('open-menu-modal', handleOpenMenu);
    return () => window.removeEventListener('open-menu-modal', handleOpenMenu);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      const isNearBottom = documentHeight - (scrollY + windowHeight) < 400;

      if (scrollY > 400 && !isNearBottom) {
        setShowStickyBtn(true);
      } else {
        setShowStickyBtn(false);
      }

      if (scrollY > 400) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isMenuOpen) {
      setIsMenuCategoriesOpen(false); // Close submenu when closing main menu
    }
  };

  const toggleMenuCategories = (e) => {
    e.preventDefault();
    setIsMenuCategoriesOpen(!isMenuCategoriesOpen);
  };

  return (
    <div className="homepage2-wrapper">
      {/* Sticky Bottom Reservation Button */}
      <div className={`sticky-reservation-container ${showStickyBtn ? "visible" : ""}`}>
        <a href="https://www.opentable.co.uk/r/chokhi-dhani-london" target="_blank" rel="noopener noreferrer" className="sticky-reservation-btn">
          <svg viewBox="0 0 180 50" preserveAspectRatio="none">
            <polygon points="15,2 165,2 177,25 165,48 15,48 3,25" fill="#0b0c0b" stroke="#e3b15a" strokeWidth="1.5" />
            <polygon points="17,4 163,4 174,25 163,46 17,46 6,25" fill="none" stroke="#e3b15a" strokeWidth="0.8" />
          </svg>
          <div className="sticky-reservation-text">Reservations</div>
        </a>
      </div>

      {/* Fullscreen Navigation Overlay */}
      <div className={`nav-overlay-gymkhana ${isMenuOpen ? "open" : ""}`}>
        <button className="nav-overlay-close" onClick={toggleMenu}>
          &times;
        </button>
        <img src="/assets/img/Chokhi_Dhani.png" alt="Chokhi Dhani Logo" className="nav-overlay-logo" />
        <div className="nav-links-container">
          <a href="/" className="nav-link-item" onClick={toggleMenu}>Home</a>
          <a href="/about-us" className="nav-link-item" onClick={toggleMenu}>About</a>
          <a href="#" className="nav-link-item" onClick={toggleMenuCategories}>Menu</a>
          <a href="/events-and-private-dining" className="nav-link-item" onClick={toggleMenu}>Events & Private Dining</a>
          {/* <a href="/terrace" className="nav-link-item" onClick={toggleMenu}>Terrace Dining</a> */}
          <a href="/kalagram" className="nav-link-item" onClick={toggleMenu}>Kalagram</a>
          <a href="/gallery" className="nav-link-item" onClick={toggleMenu}>Gallery</a>
          <a href="/contact" className="nav-link-item" onClick={toggleMenu}>Contact</a>
        </div>
      </div>

      {/* Premium Card Menu Categories Modal */}
      <div className={`menu-categories-overlay ${isMenuCategoriesOpen ? "open" : ""}`}>
        <div className="menu-categories-card">
          <button className="menu-card-close" onClick={toggleMenuCategories}>
            &times;
          </button>
          
          <h2 className="menu-card-title">MENUS</h2>
          
          <div className="menu-card-grid">
            <div className="menu-card-column">
              {menuCategories.map((cat, index) => (
                <a 
                  key={index} 
                  href={cat.category_banner_image ? menuImageUrl + cat.category_banner_image : `/menu/${cat.category_slug}`} 
                  target={cat.category_banner_image ? "_blank" : "_self"}
                  rel="noreferrer"
                  className="menu-card-item" 
                  onClick={() => { setIsMenuCategoriesOpen(false); setIsMenuOpen(false); }}
                >
                  {cat.category_name}
                </a>
              ))}
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <a 
              href="/assets/pdf/tc.pdf" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                fontSize: '14px', 
                color: '#333333', 
                textDecoration: 'none', 
                letterSpacing: '2px', 
                fontWeight: '500',
                borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                display: 'inline-block',
                paddingBottom: '5px',
                fontFamily: "'Barlow', sans-serif"
              }}
              title="Terms & Conditions"
            >
              T&C*
            </a>
          </div>
        </div>
      </div>

      {/* Header Bar */}
      <div className={`header-gymkhana ${isScrolled ? "scrolled" : ""}`}>
        <div className="header-left">
          <a href="tel:+447485365962" className="header-phone">
            <span className="header-phone-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </span>
            <span className="header-phone-text">+44 7485365962</span>
          </a>
        </div>
        
        <div className="header-center">
          <a href="/" className="logo-gymkhana-img">
            <img src="/assets/img/Chokhi_Dhani.png" alt="Chokhi Dhani Logo" />
          </a>
        </div>

        <div className="header-right">
          <button className="menu-btn-gymkhana" onClick={toggleMenu} aria-label="Toggle Navigation">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default PagesHeader;
